module.exports = __webpack_public_path__ + "static/media/nuclear-energy-permits-alerts.f802c423.svg";